import initMap from "./map";
import BusinessSearch from "./businessSearch";

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
    window.Popper = require("popper.js").default;
    window.$ = window.jQuery || require("jquery");

    require("bootstrap");
} catch (e) {}

initMap();

// Add Bootstrap responsive div around table elements
$("table").each(function () {
    $(this).addClass("table").wrap('<div class="table-responsive"></div>');
});

// Add Bootstrap responsive embed class wrapper to required elements
$('iframe[src*="youtube"], iframe[src*="vimeo"]').each(function () {
    $(this).addClass("embed-responsive-item").wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
});

// Attach Lightcase rel attribute to all gallery anchors
const galleries = document.querySelectorAll(".wp-block-gallery");
let galleryInstance = 0;

[...galleries].forEach((gallery) => {
    const anchors = gallery.querySelectorAll("a");
    [...anchors].forEach((anchor) => {
        if (!anchor.href.match(/\.(jpg|gif|png|jpeg)$/i)) {
            anchor.href = anchor.querySelector("img").src;
        }
        anchor.setAttribute("data-rel", `lightcase:galleryBlock${galleryInstance}:slideshow`);
    });

    galleryInstance++;
});

// Init lightcase
$(document).ready(function () {
    new BusinessSearch($);
    $("a[data-rel^=lightcase]").lightcase({
        maxWidth: 1024,
        maxHeight: 768,

        iframe: {
            width: 1280,
            height: 720,
            allowfullscreen: 1,
        },
    });
});

const searchToggler = document.querySelector(".search-toggler");
const headerSearchForm = document.querySelector(".header-search-form");
const headerSearchInput = headerSearchForm.querySelector(".form-control");
const searchOpen = false;

searchToggler.addEventListener("click", toggleSearchForm);

function toggleSearchForm(event) {
    window.addEventListener("keydown", handleEscape);
    document.addEventListener("click", handleClickOutside);
    headerSearchForm.classList.remove("hidden");
    searchToggler.classList.add("d-none");
    headerSearchInput.focus();
}

function handleClickOutside(event) {
    if (
        headerSearchForm === event.target ||
        headerSearchForm.contains(event.target) ||
        event.target.classList.contains("fa-search") ||
        searchToggler == event.target
    ) {
        return;
    }

    hideSearch();
}

function handleEscape(event) {
    if (event.key === "Escape") {
        hideSearch();
    }
}

function hideSearch() {
    headerSearchForm.classList.add("hidden");
    searchToggler.classList.remove("d-none");
    window.removeEventListener("keydown", handleEscape);
    document.removeEventListener("click", handleClickOutside);
}

// Navigation
const navItems = document.querySelectorAll(".primary-navigation .primary-navbar > .nav-item");
let activeItem = null;

[...navItems].forEach((item) => {
    if (item.classList.contains("current-menu-item") || item.classList.contains("current-page-ancestor")) {
        activeItem = item;
        item.classList.add("active");
    }

    // We only want to add event listeners to items that have children
    // abort this iteration if it doesn't have children
    if (!item.classList.contains("menu-item-has-children")) {
        return;
    }

    let anchor = item.querySelector(".nav-link");

    // Add click events to parents of sub menus
    anchor.addEventListener("click", (event) => {
        event.preventDefault();
        if (activeItem) {
            activeItem.classList.remove("active");
        }
        activeItem = item;
        activeItem.classList.add("active");
    });
});

const navToggler = document.querySelector(".navbar-toggler");
const navTogglerInner = document.querySelector(".navbar-toggler-inner");
const navTogglerIcon = navToggler.querySelector("span");
const navigation = document.querySelector(".primary-navigation");

// Menu Slider
const sliderImages = document.querySelectorAll(".nav-slider-image");
let currentImageIndex = 0;
let currentImage = sliderImages[currentImageIndex];
let timer;

if (currentImage) {
    currentImage.classList.add("active");
}

navTogglerInner.addEventListener("click", () => {
    handleNavOpenClose();
});

navToggler.addEventListener("click", () => {
    handleNavOpenClose();
});

const handleNavOpenClose = function () {
    navTogglerIcon.classList.toggle("fa-bars");
    navTogglerIcon.classList.toggle("fa-times");
};

const navSlider = function () {
    if (navigation.classList.contains("show")) {
        if (timer) {
            clearInterval(timer);
            currentImageIndex = 0;
        }

        return;
    }

    timer = setInterval(() => {
        // If we have hit the last slide, let's stop processing this
        if (currentImageIndex >= sliderImages.length - 1) {
            clearInterval(timer);
            return;
        }

        currentImageIndex++;

        currentImage.classList.remove("active");
        currentImage = sliderImages[currentImageIndex];
        currentImage.classList.add("active");
    }, 5000);
};

// homepage tweets
$(".tweet-list").each(function (n, el) {
    var $el = $(el);
    var numTweets = $el.data("num-tweets") || 1;

    $.get("/wp-json/ff-twitter/v1/list/" + numTweets, function (data) {
        for (var i = 0; i < data.length; i++) {
            var item = data[i];
            var $tweet = $('<div class="tweet"></div>');
            var date = formatDate(new Date(item.time * 1000));
            var text = item.text.replace(/https?:\/\/[a-zA-Z0-9\.\/]+/gi, "");

            $tweet.append('<a class="tweet-text" href="' + item.permalink + '" target="_blank">' + text + "</a>");
            $tweet.append(
                '<a class="tweet-footer" href="http://twitter.com/SSCommunicate" target="_blank"><span class="tweet-source">@' +
                    item.name +
                    '</span> &bull; <span class="tweet-date">' +
                    date +
                    "</span></a>"
            );

            $el.append($tweet);
        }
    });
});

function formatDate(date) {
    var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return day + " " + monthNames[monthIndex].substr(0, 3) + " " + year;
}

const homeVideo = document.querySelector(".home-video");

if (homeVideo) {
    let player = new Vimeo.Player(homeVideo, {
        id: homeVideo.dataset.videoId,
        width: 1280,
        loop: true,
        autoplay: true,
        background: true,
        muted: true,
    });
}
